const UserRoles = {
    ADMIN: 1,
    REGULAR: 2,
    LMS_CONFIGURATOR: 3,
    REPORT_VIEWER: 4,
    IMPERSONATOR: 5,
    BETA_TESTER: 6,
    SYSTEM_ADMIN: 7,
    USER_MANAGER: 8,
    SHOP_USER: 9,
    CL_LIBRARIAN: 10,
}

export const getRoleName = role => {
    const mapping = {
        [UserRoles.ADMIN]: 'Admin',
        [UserRoles.REGULAR]: 'Regular',
        [UserRoles.LMS_CONFIGURATOR]: 'LMS',
        [UserRoles.REPORT_VIEWER]: 'Report Viewer',
        [UserRoles.IMPERSONATOR]: 'Impersonator',
        [UserRoles.BETA_TESTER]: 'Beta Tester',
        [UserRoles.SYSTEM_ADMIN]: 'System Admin',
        [UserRoles.USER_MANAGER]: 'User Manager',
        [UserRoles.SHOP_USER]: 'Shop User',
        [UserRoles.CL_LIBRARIAN]: 'CL Librarian',
    }

    return mapping[role] || 'Unknown role'
}

export const SENSE_ORGANIZATION_ID = 1003

export const isOrganizationAdmin = roles => roles.includes(UserRoles.ADMIN)
export const isSystemAdmin = (roles, organizationId) =>
    roles.includes(UserRoles.SYSTEM_ADMIN) && organizationId === SENSE_ORGANIZATION_ID
export default UserRoles
